import { DateTime } from 'luxon';

export function refineTimeStampArray(timeStampArray, timeUnit, scaleX) {
  let formatObj;
  if (
    timeUnit === 'DAYS' ||
    timeUnit === 'WEEKS' ||
    timeUnit === 'MONTHS' ||
    timeUnit === 'YEARS'
  ) {
    formatObj = { month: 'numeric', day: 'numeric' };
  } else formatObj = DateTime.TIME_24_SIMPLE;
  const formatTimeStamp = (timeStamp, index) => {
    if (timeStamp == null || !Number.isFinite(Number(timeStamp))) {
      return null;
    }
    return {
      xPos: scaleX(index),
      time: DateTime.fromMillis(Number(timeStamp))
        .setZone('America/New_York')
        .toLocaleString(formatObj),
    };
  };
  let labelStride = 1;
  if (timeStampArray.length > 160) labelStride = 32;
  else if (timeStampArray.length > 80) labelStride = 16;
  else if (timeStampArray.length > 40) labelStride = 8;
  else if (timeStampArray.length > 20) labelStride = 4;
  else if (timeStampArray.length > 10) labelStride = 2;

  return timeStampArray.reduce((labels, timeStamp, index) => {
    if (index % labelStride !== 0) {
      return labels;
    }
    const label = formatTimeStamp(timeStamp, index);
    if (label) {
      labels.push(label);
    }
    return labels;
  }, []);
}
